import { ReactNode } from "react";
import { sanitiseQueryParams } from "@/utils/queryUtils.ts";
import { LinkWithoutPrefetch } from "@/components/__shared__/LinkWithoutPrefetch/LinkWithoutPrefetch";

export const SanitisingLink = ({
  href,
  children,
  ...props
}: {
  href: string;
  children: ReactNode;
}) => {
  const url = decodeURIComponent(href).split("?");
  return (
    <LinkWithoutPrefetch
      href={`${url[0]}?${url[1] && sanitiseQueryParams(url[1])}`}
      aria-label={typeof children === "number" ? `Page ${children}` : undefined}
      {...props}
    >
      {children}
    </LinkWithoutPrefetch>
  );
};
